import { useQuery } from '@tanstack/react-query';

import { listTags } from '@/api/tag-api';

const TAGS_KEY = ['tags'] as const;

function tagsKey(siteIds: string[] | undefined) {
  return siteIds && siteIds.length > 0
    ? ([...TAGS_KEY, { siteIds: [...siteIds].sort() }] as const)
    : (TAGS_KEY as readonly unknown[]);
}

/**
 * Lists tags, optionally scoped to one or more sites (A12 / D43). Same
 * pattern as `useStaffGroups` — wizard's shift-modal multi-select scopes
 * to the active template's sites, landing's filter lists everything.
 *
 * The cache key sorts the site list so site-order permutations don't
 * spawn separate cache entries.
 */
export function useTags(siteIds?: string[]) {
  return useQuery({
    queryKey: tagsKey(siteIds),
    queryFn: () => listTags(siteIds),
  });
}
